import { useMutation, useQuery } from 'react-query';
import spedSettingsServices from './sped-settings.services';
import notificationError from '@/utils/functions/notificationError';
import { notification } from 'antd';
import { AxiosError } from 'axios';

const QUERY_SPED_SETTINGS_COMPANY = 'sped-settings/company';
const QUERY_SPED_SETTINGS_DETAIL = 'sped-settings/detail';

export function useSpedSettingsByCompanyId(companyId?: number) {
  return useQuery({
    queryKey: [QUERY_SPED_SETTINGS_COMPANY, companyId],
    queryFn: () => spedSettingsServices.settingsByCompanyId(companyId),
    enabled: !!companyId,
  });
}

export function useSpedSettingsCreate() {
  return useMutation({
    mutationFn: spedSettingsServices.settingsCreate,
    onSuccess() {
      notification.success({
        message: 'Configuração SPED criado com sucesso!',
      });
    },
    onError(error: AxiosError) {
      notificationError(error, { description: error?.response?.data?.detail });
    },
  });
}

export function useSpedSettingsEdit() {
  return useMutation({
    mutationFn: spedSettingsServices.settingsEdit,
    onSuccess() {
      notification.success({
        message: 'Configuração SPED atualizado com sucesso!',
      });
    },
    onError(error: AxiosError) {
      notificationError(error, { description: error?.response?.data?.detail });
    },
  });
}

export function useSpedSettingsDetail(settingId?: number) {
  return useQuery({
    queryKey: [QUERY_SPED_SETTINGS_DETAIL, settingId],
    queryFn: () => spedSettingsServices.settingsDetail(settingId),
    onError(error: AxiosError) {
      notificationError(error, { description: error?.response?.data?.detail });
    },
  });
}
